import { defineComponent as S, computed as m, onMounted as N, nextTick as p, ref as A, watch as B, createBlock as d, openBlock as v, withCtx as i, createElementVNode as f, createCommentVNode as k, createVNode as g, normalizeClass as M, unref as P, withModifiers as W, createTextVNode as R, toDisplayString as w } from "vue";
import { ScalarTooltip as z, ScalarButton as D } from "@scalar/components";
import { requestExampleParametersSchema as V } from "@scalar/oas-utils/entities/spec";
import x from "../../../components/ViewLayout/ViewLayoutCollapse.vue.js";
import C from "./RequestTable.vue.js";
import { useWorkspace as G } from "../../../store/store.js";
const U = { class: "text-c-2 request-meta-buttons flex whitespace-nowrap opacity-0 group-hover/params:opacity-100 has-[:focus-visible]:opacity-100" }, j = { class: "sr-only" }, I = /* @__PURE__ */ S({
  __name: "RequestParams",
  props: {
    example: {},
    environment: {},
    envVariables: {},
    workspace: {},
    title: {},
    label: {},
    paramKey: {},
    readOnlyEntries: { default: () => [] },
    invalidParams: {}
  },
  setup(t) {
    const { requestExampleMutators: s } = G(), n = m(() => t.example.parameters[t.paramKey] ?? []);
    N(() => {
      p(() => {
        y();
      });
    });
    const o = () => {
      const e = V.parse({ enabled: !1 }), a = [...n.value, e];
      s.edit(t.example.uid, `parameters.${t.paramKey}`, a);
    }, u = A(null), K = (e, a, r) => {
      const c = n.value;
      if (c.length > e) {
        const l = [...c];
        if (!l[e])
          return;
        l[e] = { ...l[e], [a]: r }, (l[e].key !== "" || l[e].value !== "") && (l[e].enabled = !0), l[e].key === "" && l[e].value === "" && l.splice(e, 1), s.edit(
          t.example.uid,
          `parameters.${t.paramKey}`,
          l
        );
      } else {
        const l = [V.parse({ [a]: r })];
        s.edit(t.example.uid, `parameters.${t.paramKey}`, l), p(() => {
          var h;
          if (!u.value)
            return;
          (h = u.value.querySelectorAll("input")[a === "key" ? 0 : 1]) == null || h.focus();
        });
      }
      e === c.length - 1 && o();
    }, $ = (e, a) => s.edit(
      t.example.uid,
      `parameters.${t.paramKey}.${e}.enabled`,
      a
    ), q = () => {
      const e = n.value.filter((a) => a.required);
      s.edit(
        t.example.uid,
        `parameters.${t.paramKey}`,
        e
      ), p(() => o());
    }, E = (e) => {
      const a = n.value;
      if (a.length > e) {
        const r = [...a];
        r.splice(e, 1), s.edit(
          t.example.uid,
          `parameters.${t.paramKey}`,
          r
        );
      }
    };
    function y() {
      if (n.value.length === 0)
        o();
      else if (n.value.length >= 1) {
        const e = n.value[n.value.length - 1];
        e && e.key !== "" && e.value !== "" && o();
      }
    }
    const T = m(
      () => n.value.filter((e) => e.key || e.value).length
    ), O = m(() => n.value.length > 1);
    B(
      () => t.example,
      (e, a) => {
        e !== a && y();
      },
      { immediate: !0 }
    );
    const b = m(() => (t.readOnlyEntries ?? []).length > 0);
    return (e, a) => (v(), d(x, {
      class: "group/params",
      itemCount: T.value
    }, {
      title: i(() => [
        R(w(e.title), 1)
      ]),
      actions: i(() => [
        f("div", U, [
          O.value ? (v(), d(P(z), {
            key: 0,
            content: "Clear optional parameters",
            placement: "left"
          }, {
            default: i(() => [
              g(P(D), {
                class: "pr-0.75 pl-1 transition-none",
                size: "sm",
                variant: "ghost",
                onClick: W(q, ["stop"])
              }, {
                default: i(() => [
                  a[0] || (a[0] = R(" Clear ")),
                  f("span", j, "All " + w(e.title), 1)
                ]),
                _: 1,
                __: [0]
              })
            ]),
            _: 1
          })) : k("", !0)
        ])
      ]),
      default: i(() => [
        f("div", {
          ref_key: "tableWrapperRef",
          ref: u
        }, [
          b.value ? (v(), d(C, {
            key: 0,
            class: M(["flex-1", { "bg-c-3/5": b.value }]),
            columns: ["32px", "", ""],
            envVariables: e.envVariables,
            environment: e.environment,
            invalidParams: e.invalidParams,
            isGlobal: "",
            isReadOnly: "",
            items: e.readOnlyEntries,
            label: e.label,
            workspace: e.workspace
          }, null, 8, ["class", "envVariables", "environment", "invalidParams", "items", "label", "workspace"])) : k("", !0),
          g(C, {
            class: "flex-1",
            columns: ["32px", "", ""],
            envVariables: e.envVariables,
            environment: e.environment,
            invalidParams: e.invalidParams,
            items: n.value,
            label: e.label,
            workspace: e.workspace,
            onToggleRow: $,
            onUpdateRow: K,
            onDeleteRow: E
          }, null, 8, ["envVariables", "environment", "invalidParams", "items", "label", "workspace"])
        ], 512)
      ]),
      _: 1
    }, 8, ["itemCount"]));
  }
});
export {
  I as default
};
